export let highPriorityIconTooltip = "_iuXHd";
export let lowPriorityIconTooltip = "UgwKKc";
export default {highPriorityIconTooltip,lowPriorityIconTooltip};